import styled from 'styled-components'

export default styled.div`
  border-color: #e0e0e0;
  border-style: solid;
  border-width: 0;
  flex: 1 1 50%;
  display: -ms-flexbox;
  -ms-flexbox: 1 1 50%;
  max-width: 50%;

  &:nth-of-type(odd) {
    padding: 18px 11px 18px 0;
  }

  &:nth-of-type(even) {
    padding: 18px 0 18px 11px;
  }

  &:nth-of-type(1), &:nth-of-type(5) {
    border-width: 0 1px 0 0;
  }

  &:nth-of-type(3) {
    border-width: 1px 1px 1px 0;
  }

  &:nth-of-type(4) {
    border-width: 1px 0 1px 0;
  }
`
